<template>
    <div class="error-404-content">
        <!-- <pre v-if="structure" v-text="structure"></pre> -->
    
        <div class="error-404-content--inner">
            <div v-for="(plugin, pluginIdx) in structure.plugins" class="error-404-content--section">
                <component :is="plugin.type" :plugin="plugin"></component>
            </div>
        </div>
    </div>
</template>

<script>
    import { get } from 'lodash';
    import { mapGetters } from 'vuex';
    
    
    export default {
        computed: {
            ...mapGetters(['partials']),
            structure() {
                return get(this, `partials['error-404']`, {});
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?383da395